
import { Drawer, Input, Select, Option, Switch } from "element-ui"
import {
  openNoAddressPop,
  formatWareImgUrl,
  noAddressCheck,
  getStockMax,
  getDeliveryMethod,
  priceFormatOther,
  customSkuKey
} from "../../utils/utils"
import { getProductDetailSpu, getProductDetail } from "../../api/gateway"
import inputNumber from "./components/inputNumber.vue"
import inputNum from "./components/input-number.vue"
import spuAttributes from "./components/spuAttributes.vue"
import { trackAddToCart, trackSelectItem, handleChangeCartNumber } from "@/utils/track"
import { handleAddToCartV2, handleModifyCartV2, getWareBySkuId } from "@/utils/cartResponse"
import emptyImg from "@/assets/images/empty_img.png"
import lazyImg from "@/components/cms/lazyImg.vue"
import customContent from "@/components/customContent.vue"
import { getRequestHeaders, getLoginStatus, formatProductParamsBy, showGlobalMessage } from "@/utils/utils"

export default {
  components: {
    [Drawer.name]: Drawer,
    [Input.name]: Input,
    [Select.name]: Select,
    [Option.name]: Option,
    [Switch.name]: Switch,
    inputNumber,
    inputNum,
    lazyImg,
    spuAttributes,
    customContent
  },
  props: {
    addCart: {
      type: Boolean,
      default: true
    },
    visible: {
      type: Boolean,
      default: false
    },
    addressList: {
      type: Array,
      default: () => []
    },
    configs: {
      type: Object,
      default: () => {},
      required: true
    },
    shouldUseInputNumber: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lastSkuId: "", // 记录上一个选中的skuId
      max: 99,
      curValue: 1, // 当前商品数量
      curCount: 1, // 当前变化的商品数量
      goodsChange: {}, // 点击商品区域
      goodsInfo: null, // 商品详情
      baseInfo: {},
      editVisible: false,
      drawer: false,
      action: "",
      curSku: null,
      customValue: "defaultOption",
      customText: "",
      customContentConfig: null,
      curRemainingMaxCount: null
    }
  },

  computed: {
    customDisabledText() {
      if (this.goodsInfo?.currentSku?.wareStatus === -1) {
        return this.$t("sku.commingSoon")
      } else if (
        this.goodsInfo?.currentSku?.wareStatus === 9 ||
        this.goodsInfo?.currentSku?.wareStatus === 2 ||
        this.goodsInfo?.currentSku?.showNotAvailable
      ) {
        return this.$t("sku.blacklist")
      } else {
        return this.$t("sku.soldOut")
      }
    },
    findSimilarLink() {
      const {
        currentSku: { skuId, wareName },
        spuId
      } = this.goodsInfo
      return `${this.MAIN_ORIGIN}${this.MAIN_PATH}/similar?skuId=${skuId}`
      // const {
      //   currentSku: { skuId, wareName },
      //   spuId
      // } = this.goodsInfo
      // // Base URL
      // let url = `${this.MAIN_ORIGIN}${this.MAIN_PATH}/similar?`

      // // 1. 先添加 `skuId`（优先使用 `skuId`，否则用 `sku`）
      // url += `skuId=${skuId || sku}`

      // // 2. 再添加 `spuId`（如果存在）
      // if (spuId) {
      //   url += `&spuId=${spuId}`
      // }
      // // 3. 最后添加 `name`（需要 `encodeURIComponent` 防止特殊字符破坏 URL）
      // if (wareName) {
      //   url += `&name=${encodeURIComponent(wareName)}`
      // }
      // return url
    },
    // 跳转商品详情
    detailLink() {
      const {
        currentSku: { skuId, wareName },
        spuId
      } = this.goodsInfo || {}
      // Base URL
      let url = `${this.MAIN_ORIGIN}${this.MAIN_PATH}/productDetails?`

      // 1. 先添加 `skuId`（优先使用 `skuId`，否则用 `sku`）
      url += `skuId=${skuId}`

      // 2. 再添加 `spuId`（如果存在）
      if (spuId) {
        url += `&spuId=${spuId}`
      }
      // 3. 最后添加 `name`（需要 `encodeURIComponent` 防止特殊字符破坏 URL）
      if (wareName) {
        url += `&name=${encodeURIComponent(wareName)}`
      }
      return url
    },
    remainingMaxCount() {
      if (this.curRemainingMaxCount !== null) {
        return this.curRemainingMaxCount
      }
      return Object.hasOwn(this.configs, "remainingMaxCount") ? this.configs.remainingMaxCount : -1
    }
  },

  watch: {
    visible: {
      immediate: true, // 添加 immediate 确保初始化时执行
      handler(val) {
        this.drawer = val
        this.goodsChange = this.configs
        if (this.drawer) {
          this.resetCustomConfig()
          this.lastSkuId = ""
          this.fetchData(this.goodsChange.additional)
        }
      }
    },
    defaultMax: {
      handler(newVal) {
        this.max = newVal
      },
      immediate: true
    }
  },
  created() {
    if (!process.client) {
      return
    }
    const { commonReqParams } = this.$commonParams
    this.commonReqParams = commonReqParams
  },
  mounted() {},
  methods: {
    getStockMax,
    trackSelectItem,
    priceFormatOther,
    handleChangeCartNumber,
    resetCustomConfig() {
      this.$nextTick(() => {
        this.$refs?.customContent?.reset()
      })
    },
    updateCustomValue(value) {
      this.customValue = value
    },
    updateCustomText(value) {
      this.customText = value
    },
    fetchClick(obj) {
      this.curSku = obj.sku.skuId
      this.fetchData(obj.additional, obj.sku)
    },
    getCustomParams(isUpdate = false, count) {
      // 修改商品备注时从可定制的sku切换到普通sku
      if (isUpdate && this.configs.additional?.savedCustomText && !this.customContentConfig) {
        const params = {
          count,
          checked: 1,
          oldRemarkReq: this.configs.additional?.savedCustomText
        }

        return {
          customisationList: [params]
        }
      } else if (this.customContentConfig) {
        const params = {
          count,
          checked: 1,
          remarkReq: this.customValue === "defaultOption" ? "Default" : this.customText,
          remarkType: this.customValue
        }
        if (isUpdate) {
          params.oldRemarkReq = this.configs.additional?.savedCustomText
        }

        return {
          customisationList: [params]
        }
      } else {
        return {}
      }
    },
    async handleSave() {
      if (
        !this.curCount ||
        this.goodsInfo.currentSku.wareStatus !== 0 ||
        (this.customContentConfig && this.customValue === "customOption" && !this.customText)
      ) {
        return
      }
      handleChangeCartNumber(this.curCount, this.configs.addCartCount || 0, this.configs)
      // 同步相同sku商品加购数量
      const { venderId, storeId, sku, count, beforeCount } = this.goodsChange.additional
      // console.log(this.goodsChange.additional, this.curSku, "skuskuskusku")
      try {
        const [error, data] = this.addCart
          ? await handleAddToCartV2({
              venderId,
              storeId: storeId || this.commonReqParams.storeId,
              wares: [{ sku: this.curSku, count: this.curCount, checked: 1 }],
              sort: 1,
              otherParams: {
                ...this.getCustomParams(false, this.curCount)
              }
            })
          : await handleModifyCartV2({
              venderId,
              storeId: storeId || this.commonReqParams.storeId,
              wares: [{ sku: this.curSku, count: 2 * count, checked: 1 }],
              otherParams: {
                oldSkuId: sku,
                beforeCount,
                ...this.getCustomParams(true, count)
              },
              sort: 1
            })
        if (data) {
          this.curValue = 1
          const curWare = getWareBySkuId(data, this.curSku) || {}
          this.curRemainingMaxCount = curWare.remainingMaxCount
          if (data.overToast) {
            showGlobalMessage({
              message: data.overToast,
              gap: 14,
              iconClass: "alert-info"
            })
          } else {
            this.$emit("close", "save")
          }
        }
        if (error && error.code === "WEB_1203") {
          // 强制更新：先重置，再赋新值
          this.curValue = 0 // 触发响应式更新
          this.$nextTick(() => {
            this.curValue = error?.data // 确保下次赋值被检测到
          })
        }
      } catch (error) {}
    },
    // 商品加购埋点处理
    handleChange(count) {
      this.curCount = count
    },
    imageUrl(url) {
      if (url) {
        return formatWareImgUrl(url)
      }
      return emptyImg
    },

    // 获取商品详情
    async fetchData(val, changeSku = null) {
      if (this.lastSkuId === changeSku?.skuId) {
        return
      }

      const preorderStoreId = this.$cookies.get("pickUpStoreId")
      let attrList = []
      if (changeSku) {
        attrList = changeSku?.spuAttributeInfos.map(val => {
          return {
            attrId: val.attrId,
            attrValueId: val.attrValueId
          }
        })
      }
      try {
        const { data, code } = await getProductDetailSpu(
          {
            param: {
              preorderStoreId,
              skuId: !changeSku?.skuId ? val.sku : changeSku?.skuId,
              spuId: val.spuId,
              lastSkuId: this.lastSkuId,
              attrList
            },
            comm: {}
          },
          {
            loading: true
          }
        )

        if (data) {
          this.goodsInfo = data
          if (data.currentSku.skuId) {
            const productDetail = await getProductDetail(
              {
                param: {
                  preorderStoreId,
                  skuId: data.currentSku.skuId,
                  spuId: val.spuId
                },
                comm: {}
              },
              {
                loading: true
              }
            )
            this.baseInfo = productDetail.data.baseInfo

            this.customContentConfig = productDetail?.data?.baseInfo?.preferenceList?.find(
              item => item.preferenceKey === customSkuKey
            )

            this.resetCustomConfig()

            // 获取当前商品的merchantId
            const { provincial } = JSON.parse(localStorage.getItem("curSelStore") || "{}")
            if (provincial) {
              if (
                (productDetail.data.baseInfo.merchantId !== 2 &&
                  { 0: 810000, 1: 820000 }[productDetail.data.baseInfo.merchantId] !== provincial) ||
                productDetail.data.baseInfo.inBlackList
              ) {
                this.$set(this.goodsInfo.currentSku, "showNotAvailable", true)
              } else {
                this.$set(this.goodsInfo.currentSku, "showNotAvailable", false)
              }
            } else {
              this.$set(this.goodsInfo.currentSku, "showNotAvailable", false)
            }
          }
          this.lastSkuId = data.currentSku.skuId
          this.curSku = data.currentSku.skuId
        }
        this.curValue = 1
        this.resetCustomConfig()
      } catch (err) {}
    },

    handleClose() {
      this.skuVisible = false
      this.$emit("close", "cancel")
    }
  }
}
